module.exports = __webpack_public_path__ + "img/generic-connection.bb10639d.png";